<template>
  <Suspense>
    <template #default>
      <router-view />
    </template>
    <template #fallback>
      <span>Loading screen!</span>
    </template>
  </Suspense>
</template>
